"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArgsFromInvocationKey = exports.createActionInvocationKey = exports.clearOldState = exports.callMutationMethod = exports.processActionResult = void 0;
var api_clients_1 = require("../../../api-clients");
var utils_1 = require("../../../utils");
var connectorStore_1 = require("../../connectorStore");
var error_1 = require("../../error");
var response_1 = require("../../response");
var variant_1 = require("../../variant");
// We store the old variant object in redux and the hooks are built on top of that mechanism,
// this allows us to share much of the code for the old HOC and the new hooks, this function maps that
// old variant object to our newer MutationResult object.
function processActionResult(state) {
    if (!state ||
        state.variant.status === variant_1.Status.Unknown ||
        state.variant.status === variant_1.Status.Pending) {
        return { loading: true };
    }
    if (state.variant.error) {
        return {
            error: state.variant.error,
            loading: false,
            response: state.variant.result,
        };
    }
    if (state.variant.status === variant_1.Status.Success) {
        return { response: state.variant.result };
    }
    return {};
}
exports.processActionResult = processActionResult;
function callMutationMethod(args, mutationMethod, invocationKey, store) {
    return __awaiter(this, void 0, void 0, function () {
        var result, e_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectorStore_1.setPending(store, invocationKey);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, mutationMethod(args)];
                case 2:
                    result = _a.sent();
                    connectorStore_1.setSuccess(store, invocationKey, response_1.serializeResponse(result));
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    return [4 /*yield*/, error_1.normalizeError(e_1)];
                case 4:
                    error = _a.sent();
                    connectorStore_1.setError(store, invocationKey, error);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.callMutationMethod = callMutationMethod;
function clearOldState(invocationKeys, store) {
    invocationKeys.forEach(function (invocationKey) { return connectorStore_1.clearValue(store, invocationKey); });
}
exports.clearOldState = clearOldState;
function createActionInvocationKey(method, args) {
    return api_clients_1.getMethodKey(method) + "-" + utils_1.uniqueGUID() + ":args(" + JSON.stringify(args) + ")";
}
exports.createActionInvocationKey = createActionInvocationKey;
function getArgsFromInvocationKey(invocationKey) {
    try {
        return JSON.parse(invocationKey.match(/:args\((.*)\)$/)[1]);
    }
    catch (e) {
        console.error("error extracting args from invocation key, returning empty object", e);
        return {};
    }
}
exports.getArgsFromInvocationKey = getArgsFromInvocationKey;
//# sourceMappingURL=bulkMutationFunctions.js.map